import { render, staticRenderFns } from "./BlockFooter.vue?vue&type=template&id=1a3eeef2&scoped=true"
import script from "./BlockFooter.vue?vue&type=script&lang=js"
export * from "./BlockFooter.vue?vue&type=script&lang=js"
import style0 from "./BlockFooter.vue?vue&type=style&index=0&id=1a3eeef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3eeef2",
  null
  
)

export default component.exports